module.exports = __webpack_public_path__ + "img/logo.f5ed1a08.png";